var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.member.userName)+"("+_vm._s(_vm.member.userCode)+")")])}
var staticRenderFns = []

export { render, staticRenderFns }